module.exports = __webpack_public_path__ + "static/media/news.2a48b564.png";